import React from 'react';

import { Group, Stack, Text } from '@mantine/core';

import formatDate from '@/utils/formatDate';

import { ReportInfo } from '@/types/patientList';

import styles from './cells.module.scss';
import { ReportName } from './ReportName';

interface CurrentReportCellProps {
  report: ReportInfo | null;
}

export const CurrentReportCell: React.FC<CurrentReportCellProps> = ({ report }) => {
  const getStatusText = (report: ReportInfo) => {
    switch (report.signatureStatus) {
      case 'SIGNED':
        return 'Pending Physician Review';
      case 'NOT_SIGNED':
        return 'Draft';
      case 'DISMISSED':
        return 'Dismissed';
      default:
        return 'Pending Physician Review';
    }
  };

  const formatLastUpdated = (createdAt: string) => {
    if (!createdAt) return 'N/A';
    try {
      const date = new Date(createdAt);
      return (
        formatDate(date, 'MM-DD-YYYY') +
        ' at ' +
        date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        })
      );
    } catch {
      return createdAt;
    }
  };

  if (!report) {
    return (
      <Group className={styles.reportCell}>
        <Text className={styles.noReportText}>No current report</Text>
      </Group>
    );
  }

  return (
    <Group className={styles.reportCell} align="flex-start">
      <Stack className={styles.reportContent}>
        <ReportName report={report} />
      </Stack>

      <Stack className={styles.statusSection}>
        <Text className={styles.statusText}>{getStatusText(report)}</Text>
        <Text className={styles.lastUpdatedText}>
          Last Updated {formatLastUpdated(report.createdAt)}
        </Text>
      </Stack>
    </Group>
  );
};
